import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
import Types from "../actions/types";
import { onListFailed, onListSuccess } from "../actions";
import * as fromOrganisations from "features/organisations";
import * as fromAccount from "features/account/actions/types";

const leaveTypeListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			Types.LEAVE_TYPE_LIST_REQUESTED,
			Types.LEAVE_TYPE_CREATE_SUCCEEDED,
			Types.LEAVE_TYPE_UPDATE_SUCCEEDED,
			Types.LEAVE_TYPE_DELETE_SUCCEEDED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED,
			fromAccount.FEATURE_FLAGS_FETCH_SUCCESS
		),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => tokenExists()),
		filter(() => state$.value.queue.hasNetwork),
		filter(() => state$.value.featureFlags?.leave === true),
		mergeMap(() => {
			return ajax
				.get(
					`${getOrganisationBaseUrl(state$.value)}/organisation-leave-type/all`,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListSuccess(ajaxResponse.response))
					),
					catchError((error) => {
						// API returns 400 when leave feature is disabled for this organisation.
						// Treat that as "no leave types" instead of an error to avoid noisy logs.
						if (error && error.status === 400) {
							return of(onListSuccess([]));
						}
						return of(onListFailed(error));
					})
				);
		})
	);

export default leaveTypeListEffect;
